<template>
  <div class="container">
    <div class="account-wrap">
			<div class="account-title-wrap">
				<h6 class="account-title">账号登录方式</h6>
				<p>您可以使用账号、邮箱及手机三种方式进行登录</p>
			</div>
			<div class="account-list">
				<div class="account-icon">
					<img src="../../../assets/account_icon_01.png" />
				</div>
				<div class="account-txt clearfix">
					<div class="account-txt-l">
						<h6>账号名</h6>
						<p>chuxiao911</p>
					</div>
					<div class="account-txt-r">
						<span class="user-btn">更改</span>
					</div>
				</div>
			</div>
			<div class="account-list">
				<div class="account-icon">
					<img src="../../../assets/account_icon_02.png" />
				</div>
				<div class="account-txt clearfix">
					<div class="account-txt-l">
						<h6>手机号</h6>
						<p>chuxiao911</p>
					</div>
					<div class="account-txt-r">
						<span class="user-btn">绑定</span>
					</div>
				</div>
			</div>
			<div class="account-list">
				<div class="account-icon">
					<img src="../../../assets/account_icon_03.png" />
				</div>
				<div class="account-txt clearfix">
					<div class="account-txt-l">
						<h6>邮件地址</h6>
						<p>chuxiao911</p>
					</div>
					<div class="account-txt-r">
						<span class="user-btn">更改</span>
					</div>
				</div>
			</div>
		</div>
		<div class="account-wrap account-wrap2">
			<div class="account-title-wrap">
				<h6 class="account-title">安全中心</h6>
			</div>
			<div class="account-list">
				<div class="account-icon">
					<img src="../../../assets/account_icon_04.png" />
				</div>
				<div class="account-txt clearfix">
					<div class="account-txt-l">
						<h6>重置账号密码</h6>
						<p>上次重置时间：2020.09.23</p>
					</div>
					<div class="account-txt-r">
						<span class="user-btn">重置</span>
					</div>
				</div>
			</div>
			<div class="account-list">
				<div class="account-icon">
					<img src="../../../assets/account_icon_05.png" />
				</div>
				<div class="account-txt clearfix">
					<div class="account-txt-l">
						<h6>安全邮箱</h6>
						<p>chuxiao911</p>
					</div>
					<div class="account-txt-r">
						<span class="user-btn">设置</span>
					</div>
				</div>
			</div>
			<div class="account-list">
				<div class="account-icon">
					<img src="../../../assets/account_icon_06.png" />
				</div>
				<div class="account-txt clearfix">
					<div class="account-txt-l">
						<h6>安全手机</h6>
						<p>未设置</p>
					</div>
					<div class="account-txt-r">
						<span class="user-btn">设置</span>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
export default {
  name: '',
  components: {
    
  }
}
</script>

<style scoped>
.account-wrap2{margin-top: 60px}
.account-title{font-size: 18px; line-height: 36px; font-weight: 400;}
.account-title-wrap p{color:#797979; line-height: 27px;}
.account-list{position: relative;}
.account-icon{width: 50px; height: 50px; position: absolute; left:0; top:18px}
.account-txt{margin-left: 60px; padding: 15px 0; border-bottom: 1px solid #E5E5E5;}
.account-txt-l{float: left;}
.account-txt-l h6{padding-bottom:5px; font-size:17px; font-weight: 400}
.account-txt-l p{color:#828282; font-size: 14px; line-height: 20px;}
.account-txt-r{float:right}
.user-btn{display:block; width: 102px; height: 34px; margin-top:5px; background: #F7F7F7; border-radius: 4px; text-align: center; color:#0981FF; font-size: 14px; line-height: 34px;}
</style>
